import { Navbar, Footer } from "@/components/landing";
import { EquipScoutCaseStudy } from "@/components/work/equip-scout/EquipScoutCaseStudy";

export function WorkEquipScoutPage() {
  return (
    <div className="page text-ink">
      <Navbar />
      <main>
        <div className="h-24 lg:h-28" aria-hidden="true" />
        <EquipScoutCaseStudy />
      </main>
      <Footer />
    </div>
  );
}
